import { useEffect } from "react";
import { useSearch } from "wouter";

export const NEW_WORK_PARAM = "newWork";
export function isNewWorkSearch(search: string): boolean {
  return new URLSearchParams(search).get(NEW_WORK_PARAM) === "1";
}
export function isDirectWorkSearch(search: string): boolean {
  return new URLSearchParams(search).get("directWork") === "1";
}
export function directWorkCustomerPath(customerId: number): string {
  return `/customers/${customerId}?directWork=1`;
}
export function newWorkCustomerPath(customerId: number): string {
  return `/customers/${customerId}?tab=contratos&${NEW_WORK_PARAM}=1`;
}
export type DirectWorkMode = "exception" | "legacy" | null;
// UI guard only: existing server authorization remains authoritative.
export function canSubmitDirectWork(editingId: number | null, mode: DirectWorkMode, type: string, acknowledged: boolean): boolean {
  if (editingId !== null) return true;
  if (!acknowledged) return false;
  return mode === "exception" && ["breakdown", "maintenance"].includes(type);
}
export interface NewWorkIntentState {
  customerId: number | null;
  customer?: { id: number; recordStatus: string } | null;
  canCreate?: boolean;
  failed: boolean;
}
export function newWorkIntentDecision(state: NewWorkIntentState): "wait" | "discard" | "open" {
  if (!Number.isSafeInteger(state.customerId) || (state.customerId ?? 0) <= 0 || state.failed || state.canCreate === false) return "discard";
  if (state.customer && (state.customer.id !== state.customerId || state.customer.recordStatus !== "active")) return "discard";
  if (!state.customer || state.canCreate === undefined) return "wait";
  return "open";
}
export function useNewWorkIntent(state: NewWorkIntentState, onOpen: (kind: "contract" | "exception") => void) {
  const search = useSearch();
  useEffect(() => {
    const url = new URL(window.location.href);
    const param = url.searchParams.has(NEW_WORK_PARAM) ? NEW_WORK_PARAM : "directWork";
    if (!url.searchParams.has(param)) return;
    const decision = url.searchParams.get(param) === "1" ? newWorkIntentDecision(state) : "discard";
    if (decision === "wait") return;
    url.searchParams.delete(NEW_WORK_PARAM);
    url.searchParams.delete("directWork");
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
    if (decision === "open") onOpen(param === NEW_WORK_PARAM ? "contract" : "exception");
  }, [search, state.customerId, state.customer, state.canCreate, state.failed, onOpen]);
}
